module.exports = __webpack_public_path__ + "static/media/WEBnegro_21.9516a266.png";